import { render, staticRenderFns } from "./AccountDetailTop.vue?vue&type=template&id=8e60984c&scoped=true&"
import script from "./AccountDetailTop.vue?vue&type=script&lang=js&"
export * from "./AccountDetailTop.vue?vue&type=script&lang=js&"
import style0 from "./AccountDetailTop.vue?vue&type=style&index=0&id=8e60984c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e60984c",
  null
  
)

export default component.exports